/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    let DocActions;
    (function (DocActions) {
        const LOG_CATEGORY = "WPT.DocumentActions.AddToEnvelope";
        class DocActionAddToEnvelope extends DocActions.DocActionBaseClass {
            constructor(core, name) {
                super(core, name);
                this._envComponent = null;
                this._currentModalSession = null;
                this._storeHtml = (htmlData) => {
                    this._log.info("DocActionAddToEnvelope._storeHtml()");
                    DocActionAddToEnvelope.Html = htmlData;
                    this._readyToExecute = true;
                    if (this._pendingRequest)
                        this.execute(this._pendingRequest);
                };
                this._envelopeSelected = (envelope) => {
                    this._log.info("DocActionAddToEnvelope._envelopeSelected()");
                    if (envelope) {
                        this._envComponent.addDocToEnvelope(this._pendingRequest.DocHandle, envelope.Id);
                    }
                };
                this._documentAdded = (success) => {
                    this._log.info("DocActionAddToEnvelope._documentAdded()");
                    this._core.hideModal(this._currentModalSession);
                    this._currentModalSession = null;
                };
                this._createClicked = (event) => {
                    this._log.info("DocActionAddToEnvelope._createClicked()");
                    this._envComponent.addEnvelope(null, true);
                };
                this._envelopeCreated = (envId) => {
                    this._log.info("DocActionAddToEnvelope._envelopeCreated()");
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionAddToEnvelope::constructor");
                this._label = this._core.Locale.getTranslation("STR_WPT_DA_ADDTOENVELOPE");
                // But the html is static
                if (!DocActionAddToEnvelope.Html) {
                    core.Loader.getVersionedHTML('widgets/documentactions/addtoenvelope.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToExecute = true;
                    if (this._pendingRequest)
                        this.execute(this._pendingRequest);
                }
            }
            actionAllowed(request) {
                this._log.info("DocActionAddToEnvelope.actionAllowed()");
                // There are no privileges on the doc type associated with envelopes so always true
                return true;
            }
            execute(request) {
                this._log.info("DocActionAddToEnvelope.execute()");
                this._pendingRequest = request;
                if (!this._readyToExecute) {
                    return;
                }
                let modalSession = 'add-to-envelope-modal-' + performance.now();
                if (this._log.isTraceEnabled()) {
                    this._log.trace("created modal session: " + modalSession);
                }
                let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                if (modal !== null && modal !== undefined) {
                    this._currentModalSession = modalSession;
                    modal.DIV.innerHTML = DocActionAddToEnvelope.Html;
                    let createButton = modal.DIV.querySelector('#atedaCreate');
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#atedaDialogHeading'), 'STR_WPT_DA_ADDTOENVELOPE');
                    let cancelTranslation = this._core.Locale.getTranslation('STR_WPT_CANCEL');
                    modal.DIV.querySelector('#atedaCancelLabel').innerHTML = cancelTranslation;
                    let closeIcon = modal.DIV.querySelector('#closeIcon');
                    closeIcon.setAttribute('title', cancelTranslation);
                    closeIcon.setAttribute('aria-label', cancelTranslation);
                    this._core.Helper.setElementTranslation(createButton.querySelector('#atedaCreateLabel'), 'STR_WPT_CREATE_ENVELOPE');
                    createButton.addEventListener('click', this._createClicked);
                    // Need to configure the component
                    let componentConf = {
                        SelectOnlyMode: true,
                        SelectNewEnvelopes: false,
                        ShowDelete: false,
                        ShowRemoveDoc: false
                    };
                    let componentContainer = modal.DIV.querySelector('#atedaComponentContainer');
                    this._envComponent = new WPTNamespace.Widgets.ComponentEnvelopes(this._core, componentContainer, null, componentConf);
                    this._envComponent.EnvelopeSelectedCallBack = this._envelopeSelected;
                    this._envComponent.DocumentAddedCallBack = this._documentAdded;
                    this._envComponent.EnvelopeAddedCallBack = this._envelopeCreated;
                    this._envComponent.present();
                    this._envComponent.doSearch();
                    this._core.showModal(this._currentModalSession);
                }
                else {
                    console.error("unable to show add to envelope modal, modal placeholder is already used");
                }
            }
        }
        DocActionAddToEnvelope.Html = null;
        DocActions.DocActionAddToEnvelope = DocActionAddToEnvelope;
    })(DocActions = WPTNamespace.DocActions || (WPTNamespace.DocActions = {}));
})(WPTNamespace || (WPTNamespace = {}));
